import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';
import { focusRingDecl } from 'theme/mixins';

export const StyledLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
`;

export const StyledBox = styled.span.withConfig({ shouldForwardProp })<{ checked: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.xs}px;
  border: 1.5px solid
    ${({ theme, checked }) => (checked ? theme.colors.primary : theme.colors.borderStrong)};
  background-color: ${({ theme, checked }) => (checked ? theme.colors.primary : 'transparent')};
  color: ${({ theme }) => theme.colors.onPrimary};
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
`;

export const StyledNativeInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  /* The real input is hidden, so focus rings the box it controls. */
  &:focus-visible + ${StyledBox} {
    ${focusRingDecl}
  }
`;
